import { render, staticRenderFns } from "./ResetSenha.vue?vue&type=template&id=1f4afe91"
import script from "./ResetSenha.vue?vue&type=script&lang=js"
export * from "./ResetSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports